import { combineReducers } from 'redux';

import loadBalanceError from './loadBalanceError';
import loadBalanceSummaryError from './loadBalanceSummaryError';
import loadWebmasterProfileError from './loadWebmasterProfileError';
import editWebmasterProfileError from './editWebmasterProfileError';


export default combineReducers({
  loadBalanceError,
  loadBalanceSummaryError,
  loadWebmasterProfileError,
  editWebmasterProfileError,
});
